import React from 'react';
import {IconProps} from './types';

interface IButtonProps extends IconProps{
    background: string;
}

export const Grid = ({width = 40, height = 40, color = 'black',background = 'white', ...props}:IButtonProps) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill={background}/>
            <path d="M17 17V15H15V17H17Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 25V23H15V25H17Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M25 17V15H23V17H25Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M25 25V23H23V25H25Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#BCBCCC"/>
        </svg>

    );
};
